import { createSlice } from "@reduxjs/toolkit";
import { VideoviewAction, allCategoryList, browseAddToCollectionAction, browseCategoryDetailAction, browseCategoryDetailTestAction, browseCategoryDetailTestDetailAction, browseDetailAction, collectionVideosAction, getBrowseCatagoryAction, getBrowseSearchForDidYouMeanAction, likesCategoryList, resetBrowseAction } from "../Action/BrowseAction";

const initialState = {
    categories: [],
    likesCategoryListData:[],
    data: [],
    browseDetails: {},
    browseCatagoryDetail: {},
    collectionVideosData:{},
    browseAddToCollectionStatus:"idle",
    browseCategoryDetailTestStatus:{},
    browseCategoryDetailTestDetailStatus:"idle",
    VideoviewStatus:"idle",
    didYouMeanResult: null
}
const browseSlice = createSlice({
    name: 'browse',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(allCategoryList.fulfilled, (state, action) => {
                state.categories = action?.payload?.data;
            })
            .addCase(likesCategoryList.fulfilled, (state, action) => {
                state.likesCategoryListData = action?.payload?.data;
            })
            .addCase(browseDetailAction.fulfilled, (state, action) => {
                state.browseDetails = action?.payload?.data;
            })
            .addCase(getBrowseCatagoryAction.fulfilled, (state, action) => {
                state.data = action?.payload?.data;
            })
            .addCase(browseCategoryDetailAction.fulfilled, (state, action) => {
                state.browseCatagoryDetail = action?.payload?.data;
            })

            .addCase(collectionVideosAction.fulfilled, (state, action) => {
                state.collectionVideosData = action?.payload?.data;
            })
            
            .addCase(browseAddToCollectionAction.fulfilled, (state, action) => {
                state.browseAddToCollectionStatus = "Successfully"
            })

            .addCase(browseCategoryDetailTestAction.fulfilled, (state, action) => {
                state.browseCategoryDetailTestStatus = action?.payload?.data;
            })

            .addCase(browseCategoryDetailTestDetailAction.fulfilled, (state, action) => {
                state.browseCategoryDetailTestDetailStatus = "Successfully"
            })
            
            .addCase(VideoviewAction.fulfilled, (state, action) => {
                state.VideoviewStatus = "Successfully"
            })

            .addCase(getBrowseSearchForDidYouMeanAction.fulfilled, (state, action) => {
                state.didYouMeanResult = action?.payload?.data;
            })

            .addCase(resetBrowseAction, () => initialState);
    },
});

export default browseSlice.reducer;




